module.exports = __webpack_public_path__ + "img/toastBtn.665c038e.png";